<div class="table-container">
    <mat-form-field class="search-bar" appearance="outline">
      <mat-label>Search</mat-label>
      <input matInput (keyup)="applyGlobalFilter($event)" placeholder="Search study centers">
    </mat-form-field>
    
    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
      
      <!-- Name Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
        <td mat-cell *matCellDef="let element">{{element.name}}</td>
        <td mat-footer-cell *matFooterCellDef>
          <mat-form-field>
            <input matInput (keyup)="applyColumnFilter($event, 'name')" placeholder="Filter by Name">
          </mat-form-field>
        </td>
      </ng-container>
  
      <!-- Type Column -->
      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
        <td mat-cell *matCellDef="let element">{{element.type}}</td>
        <td mat-footer-cell *matFooterCellDef>
          <mat-form-field>
            <input matInput (keyup)="applyColumnFilter($event, 'type')" placeholder="Filter by Type">
          </mat-form-field>
        </td>
      </ng-container>
  
      <!-- Ranking Column -->
      <ng-container matColumnDef="ranking">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Ranking</th>
        <td mat-cell *matCellDef="let element">{{element.ranking}}</td>
        <td mat-footer-cell *matFooterCellDef>
          <mat-form-field>
            <input matInput (keyup)="applyColumnFilter($event, 'ranking')" placeholder="Filter by Ranking">
          </mat-form-field>
        </td>
      </ng-container>
  
      <!-- Rating Column -->
      <ng-container matColumnDef="rating">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Rating</th>
        <td mat-cell *matCellDef="let element">{{element.rating}}</td>
        <td mat-footer-cell *matFooterCellDef>
          <mat-form-field>
            <input matInput (keyup)="applyColumnFilter($event, 'rating')" placeholder="Filter by Rating">
          </mat-form-field>
        </td>
      </ng-container>
  
      <!-- Location Column -->
      <ng-container matColumnDef="location">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Location</th>
        <td mat-cell *matCellDef="let element">{{element.location}}</td>
        <td mat-footer-cell *matFooterCellDef>
          <mat-form-field>
            <input matInput (keyup)="applyColumnFilter($event, 'location')" placeholder="Filter by Location">
          </mat-form-field>
        </td>
      </ng-container>
  
      <!-- Actions Column -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let element">
          <button mat-icon-button color="primary" (click)="viewDetails(element)">
            <mat-icon>info</mat-icon>
          </button>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>
  
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
    </table>
  
    <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
  </div>
  
